import { Trash2 } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "../ui/alert-dialog";

export const WipeDialog = ({ count, onWipe }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button data-testid="wipe-all-button" disabled={count === 0} className="lab-btn-ghost hover:!border-rose-400 hover:!text-rose-400"><Trash2 size={16} /> Wipe all objects</button>
    </AlertDialogTrigger>
    <AlertDialogContent className="lab-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display uppercase tracking-widest">Wipe all {count} objects?</AlertDialogTitle>
        <AlertDialogDescription className="text-slate-400">Every programmed tag, word and sound is deleted and the experiment text returns to default. This cannot be undone.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="lab-btn-ghost">Cancel</AlertDialogCancel>
        <AlertDialogAction data-testid="wipe-all-confirm" className="lab-btn-danger" onClick={onWipe}>Wipe everything</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
